<script setup lang="ts">
import { useTopbarStore } from '@/components/app/topbar-store'
import { TypedRouteLocation } from '@/types/router-location-type'

definePage({
  path: '/instellingen',
  meta: {
    permissionResource: 'CompanySettings',
  },
  redirect: { name: '/settings/UserProfile' },
})

const { t } = useI18n()

const topbarStore = useTopbarStore()

topbarStore.setAndClear({
  breadcrumbs: [ { label: t('settings.title') } ],
})

const route = useRoute()

const items: {
  label: string,
  to: TypedRouteLocation
}[] = [
  {
    label: t('settings.profile'),
    to: { name: '/settings/UserProfile' },
  },
  {
    label: t('settings.calendar.title'),
    to: { name: '/settings/Calendar' },
  },
  {
    label: t('settings.teammates.title'),
    to: { name: '/settings/Teammates' },
  },
  {
    label: t('settings.jobNotifications.title'),
    to: { name: '/settings/JobNotifications' },
  },
  {
    label: t('settings.defaultMessages.title', 2),
    to: { name: '/settings/DefaultMessages' },
  },
  {
    label: t('settings.integrations.title'),
    to: { name: '/settings/Integrations' },
  },
  {
    label: t('settings.language.title'),
    to: { name: '/settings/Language' },
  },
]
</script>

<template>
  <Card class="mx-auto max-w-screen-2xl">
    <template #title>
      <Tabs :value="route.name" scrollable>
        <TabList>
          <router-link v-for="tab in items" :key="tab.label" :to="tab.to">
            <Tab :value="tab.to.name">
              <h6>{{ tab.label }}</h6>
            </Tab>
          </router-link>
        </TabList>
      </Tabs>
    </template>
    <template #content>
      <router-view v-slot="{ Component }">
        <loading-wrapper>
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </loading-wrapper>
      </router-view>
    </template>
  </Card>
</template>
